import { render, staticRenderFns } from "./PinListBatchWise.vue?vue&type=template&id=581e58c0&scoped=true"
import script from "./PinListBatchWise.vue?vue&type=script&lang=js"
export * from "./PinListBatchWise.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "581e58c0",
  null
  
)

export default component.exports